import React from "react";

export default function UserChildrenBox({ data }) {
  return (
    <div className="col-md-3">
      <div className="user-children-box px-4 py-2 m-1 text-center corner-radius">
        <div className="d-flex">
          <div className={data.status + " dot"}></div>
          <p className={data.status + "-text"}>{data.status}</p>
        </div>
        <img
          src={data.gender === "male" ? "/images/boy.png" : "/images/girl.png"}
          width="35px"
          alt=""
        />
        <h5 className="mt-1">{data.firstName + " " + data.lastName}</h5>
      </div>
    </div>
  );
}
